/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import GroupChannelHeader from '@sendbird/uikit-react/GroupChannel/components/GroupChannelHeader';
import { GroupChannelList } from '@sendbird/uikit-react/GroupChannelList';
import { GroupChannel } from '@sendbird/uikit-react/GroupChannel';
import '@sendbird/uikit-react/dist/index.css';
import { Box } from '@mui/system';

import {
  HelpUserTypes,
  chatActiveTab,
  ClientChatTypes,
} from '@pharmaplan/common';

import { stub } from '@pharmaplan/common/helpers/utils';

import GroupChannelPreviewBase from '../../common/Chat/GroupChannelPreviewBase';
import useUserProfileLink from '../../../hooks/Admin/useUserProfileLink';
import { renderScreen, setOpen } from '../../../actions/drawerActions';
import GroupHeaderSearch from '../../common/Chat/GroupHeaderSearch';
import useChatWindow from '../../../hooks/Chat/useChatWindow.self';
import useNewMetadata from '../../../hooks/Chat/useNewMetadata';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import useChatSearch from '../../../hooks/Chat/useChatSearch';
import { setDialog } from '../../../reducers/dialogReducer';
import { ScreenTypes } from '../../../helpers/Constants';
import ChatSidebar from '../../common/Chat/ChatSidebar';
import strings from '../../../localization';

import CreateGroupDialog from './CreateGroupDialog';
import GroupChannelTitle from './GroupChannelTitle';
import CustomMessage from './CustomMessage';
import MessageInput from './MessageInput';
import styles from './styles';
import './style.css';

const ChatWindow = () => {
  const dispatch = useAppDispatch();

  const { formik } = useChatSearch();

  const activeTab = useAppSelector(chatActiveTab);

  const isSupportChat = activeTab !== ClientChatTypes.users;
  const { channelUrl, beforeSendMessage, handleChannelSelect } = useChatWindow();

  const { goToUserProfile } = useUserProfileLink();

  const showDialog = () => {
    dispatch(
      setDialog({
        showCloseButton: true,
        heading: {
          title: strings.newChat,
        },
        maxWidth: 'sm',
        Component: <CreateGroupDialog />,
      }),
    );
  };

  const handleProfileClick = () => {
    const splitPersonnel = channelUrl.personnelId?.split?.(',');
    const { length } = splitPersonnel ?? {};
    if (length === 1) {
      goToUserProfile({
        personnelId: channelUrl.personnelId,
        userType:
          HelpUserTypes[channelUrl.userType as keyof typeof HelpUserTypes],
      })();
    } else {
      dispatch(setOpen(true));
      dispatch(
        renderScreen({
          screenType: ScreenTypes.chat,
          screenNumber: 1,
          eventIds: splitPersonnel,
        }),
      );
    }
  };

  useNewMetadata();
  const containerClassName = formik.values.showSearch ? 'admin' : '';

  return (
    <Box sx={styles.container}>
      <ChatSidebar />
      <Box component="div" className={containerClassName} sx={styles.container}>
        <GroupChannelList
          channelListQueryParams={{
            channelNameContainsFilter: formik.values.searchText,
          }}
          selectedChannelUrl={channelUrl.url}
          disableAutoSelect
          renderHeader={() =>
            (
              <GroupHeaderSearch
                formik={formik}
                showDialog={isSupportChat ? showDialog : null}
              />
            )}
          isMessageReceiptStatusEnabled
          renderChannelPreview={(props) =>
            (
              <GroupChannelPreviewBase {...props} />
            )}
          onChannelSelect={handleChannelSelect}
          onChannelCreated={stub}
        />

        {channelUrl && (
          <GroupChannel
            onBeforeSendUserMessage={beforeSendMessage}
            onChatHeaderActionClick={handleProfileClick}
            channelUrl={channelUrl.url}
            renderChannelHeader={(props) =>
              (
                <GroupChannelHeader
                  {...props}
                  renderLeft={() =>
                    <div />}
                  renderMiddle={() =>
                    (
                      <GroupChannelTitle
                        isViewingEngagedChannel={channelUrl.isEngaged}
                        title={channelUrl.channelName}
                        url={channelUrl.url}
                      />
                    )}
                />
              )}
            renderMessageInput={() =>
              (
                <MessageInput isEngaged={channelUrl.isEngaged} />
              )}
            renderMessage={CustomMessage}
          />
        )}
      </Box>
    </Box>
  );
};

export default ChatWindow;
